<template>
  <component
    :is="componentName"
    v-bind="$attrs"
    class="tw-inline-flex tw-cursor-pointer tw-select-none tw-items-center tw-justify-center tw-font-medium tw-outline-none tw-transition-all hover:tw-shadow-transparent hover:[box-shadow:none] focus:tw-outline-none disabled:tw-cursor-not-allowed"
    :class="[
      `${color}-button`,
      sizes[size],
      { 'tw-w-full': isBlock, 'tw-rounded-full': isRounded },
    ]"
    :disabled="isDisabled"
    :href="href && !isDisabled ? href : false"
    :test_id="$attrs.test_id"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { ButtonColorType } from '@/shared/data/buttonColorTypes'

const props = withDefaults(
  defineProps<{
    color?: ButtonColorType
    size?: 'regular' | 'small' | 'large' | 'xs'
    isDisabled?: boolean
    isBlock?: boolean
    href?: string
    isInertiaLink?: boolean
    isRounded?: boolean
  }>(),
  {
    color: 'secondary',
    size: 'regular',
    isDisabled: false,
    isBlock: false,
    href: '',
    isInertiaLink: false,
    isRounded: true,
  },
)

const sizes = {
  xs: 'tw-text-[11px] tw-py-1 tw-px-2',
  small: 'tw-px-4 tw-py-2 tw-text-[13px]',
  regular: 'tw-px-4 tw-py-2 tw-text-sm',
  large: 'tw-py-3 tw-px-6 tw-text-base',
}

const componentName = computed(() => {
  if (props.isDisabled) return 'button'
  if (props.href) return props.isInertiaLink ? 'InertiaLink' : 'a'
  return 'button'
})
</script>
